

























































































import { IBanner } from '~/types/banner';
import { Vue, Component, Prop } from 'vue-property-decorator';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import { kebabCase } from 'lodash';

@Component({})
export default class PromoBannerCarousel extends Vue {
  @Prop() banners!: IBanner[];

  mounted() {
    const el = this.$refs?.swiperContainer as HTMLElement;
    if (!el) {
      return;
    }

    new Swiper(el, {
      slidesPerView: 1,
      modules: [Navigation, Pagination, Autoplay],
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
      },
      loop: true,
      spaceBetween: 5,
      speed: 350,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  kebabText(text: string) {
    return kebabCase(text);
  }

  bannerClicked(activeBanner: IBanner) {
    if (activeBanner) {
      if (activeBanner.externalLink) {
        window.location.href = activeBanner.externalLink;
      } else if (activeBanner.internalRoute) {
        if (activeBanner.internalRoute.startsWith('/')) {
          this.$router.push(activeBanner.internalRoute);
        } else {
          // Hack - temporary fix because we don't have a proper way to specify an external link in our Sanity schema
          window.location.href = activeBanner.internalRoute;
        }
      }
    }
  }
}
